export const MEDIA_BREAKPOINTS = {
  mobile: "(max-width: 599px)",
  tablet: "(min-width: 600px) and (max-width: 991px)",
  desktop: "(min-width: 992px)"
};
